module.exports = __webpack_public_path__ + "static/img/login_text.e7b0679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_text.png
// module id = huCl
// module chunks = 210